<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        积分明细
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
       <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        
        <el-table-column prop="mobile" width="160" label="用户账号" align="center"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" align="center"></el-table-column>
        <el-table-column  label="会员等级" align="center"></el-table-column>
        <el-table-column prop="integral" width="170" label="可用积分" align="center"></el-table-column>

        <el-table-column prop="all_integral" label="历史积分" align="center"></el-table-column>
        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="dialogVisible = true ,amend(scope.row.mobile),addFun()"  class="button1">修改数值</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search">
          <el-col :span="4">
            <div class="label">操作时间:</div>
          </el-col>
          <el-col :span="15">
            <template>
              <div class="block">     
                <el-date-picker
                  v-model="value1"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData2" border style="width: 100%" ref="multipleTable">
        
        <el-table-column prop="from" label="积分来源" align="center"></el-table-column>
        <el-table-column prop="number" label="积分变化" align="center"></el-table-column>
        <el-table-column prop="timeNew" label="时间" align="center"></el-table-column>
        <el-table-column prop="str"  label="备注" align="center"></el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="8"></el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
     <el-dialog title="修改数值" :visible.sync="dialogVisible" width="33%">
      <el-form >
        <el-form-item label="调整积分:">
          <template>
            <div style="position: relative;">
              <el-radio  v-model="radio" label="add" @change="addFun">增加</el-radio>
              <el-input style="width:300px" placeholder="请输入大于0的整数" :disabled = "show1" v-model="add" autocomplete="off"></el-input>
              <div class="num">个</div>
            </div>
            <div style="margin-top:16px;margin-left:72px; position: relative;">
              <el-radio  v-model="radio" label="minus" @change="minusFun">减少</el-radio>
              <el-input :disabled = "show2" placeholder="请输入大于0的整数" style="width:300px" v-model="minus" autocomplete="off"></el-input>
              <div class="num">个</div>
            </div>
          </template>

        </el-form-item>
        
        <el-form-item   label="备注信息:">
         <textarea name="" id="" cols="51" rows="10" v-model="remark"> </textarea>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false,submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return { 
      serve: this.$store.state.serve,
      show1: false,
      show2: false,
      remark:"",
      add:"",
      minus:"",
      radio: 'add',
      dialogVisible: false,
      mobile1 :'',
      
      value1: '',
      mobile: this.$route.params.id,
      tableData: [],
      tableData2:[],
      total: 0,
      page: null,
/////////////////////////////
     
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "积分查询";
    this.geting();
  },
 
  methods: {
    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/home_integral_detail", {
          params: {
            token: this.token,
            username: this.username,
            mobile: this.mobile,
            time: this.value1,
            page: page
          }
        })
        .then(res => {
          that.tableData = [];
          that.tableData2 = [];
          var json = res.data.data;
          that.page = json.page;
          that.total = json.total;
          that.tableData.push(json.head)
          for(var key in json.results){
            that.tableData2.push(json.results[key])
            var time = json.results[key].create_date;
            var timeNew = new Date(parseInt(time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');
            json.results[key].timeNew = timeNew;
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("修改失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "修改成功",
        type: "success"
      });
    },
    addFun(){
      if(this.radio == "add"){
        this.show2 = true;
        this.show1 = false;
      }
    },
    minusFun(){
      if(this.radio == "minus"){
        this.show1 = true;
        this.show2 = false;
      }
    },
    amend(mobile){
      this.mobile1 = mobile
    },
    submit(){
      
      if(this.radio == 'add'){
         var number = this.add
      }else if(this.radio == 'minus'){
        var number = this.minus
      }
      this.axios.get(this.serve+'/admin/integral_change_number',{
        params:{
          username : this.username,
          token : this.token,
          mobile: this.mobile1,
          sign : this.radio,
          number: number,
          remark: this.remark,
        }
      }).then(res=>{
        if(res.data.status == "success"){
          this.open()
           this.geting()
        }else if(res.data.status == "error"){
          this.open4() 
        }
       
      })
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
  .num{
    width:40px;
    height:38px;
    background:rgba(238,238,238,1);
    border:1px solid rgba(221, 221, 221, 1);
    text-align:center;
    line-height:38px;
    position: absolute;
    top: 0;
    right: 132px;   
  }
}
</style>